import axiosInstance from './axiosInstance'

export const getArtworkRequestNotesByRequestId = (requestId) => {
  return axiosInstance.get(`/artwork-request-notes?requestId=${requestId}`)
}

export const getArtworkRequestNoteById = (noteId) => {
  return axiosInstance.get(`/artwork-request-notes/${noteId}`)
}

export const createArtworkRequestNote = (data) => {
  return axiosInstance.post('/artwork-request-notes', data)
}

export const updateArtworkRequestNote = (noteId, data) => {
  return axiosInstance.put(`/artwork-request-notes/${noteId}`, data)
}

export const deleteArtworkRequestNote = (noteId) => {
  return axiosInstance.delete(`/artwork-request-notes/${noteId}`)
}

export const uploadArtworkRequestNoteAttachment = (data, onUploadProgress) => {
  return axiosInstance.post('/artwork-request-notes/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  })
}

export const deleteArtworkRequestNoteAttachmentById = (data) => {
  return axiosInstance.post('/artwork-request-notes/delete-attachment-by-id', data)
}

export const deleteArtworkRequestNoteAttachmentByPath = (data) => {
  return axiosInstance.post('/artwork-request-notes/delete-attachment-by-path', data)
}
